import { motion } from "framer-motion";

/**
 * Reveal — a scroll-triggered fade/translate reveal.
 * Use inline for individual elements or wrap sections for staggered children.
 */
export function Reveal({
  children,
  y = 32,
  delay = 0,
  duration = 0.9,
  once = true,
  className = "",
  as = "div",
}) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration, ease: [0.19, 1, 0.22, 1], delay }}
      className={className}
    >
      {children}
    </MotionTag>
  );
}

export function StaggerContainer({ children, className = "", stagger = 0.08 }) {
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      variants={{
        hidden: {},
        visible: { transition: { staggerChildren: stagger } },
      }}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className = "", y = 28 }) {
  return (
    <motion.div
      className={className}
      variants={{
        hidden: { opacity: 0, y },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.9, ease: [0.19, 1, 0.22, 1] },
        },
      }}
    >
      {children}
    </motion.div>
  );
}
